import React from 'react';
export function DeletionConfirmationTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-389">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-390">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-391" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-392">
        <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        marginTop: '0'
      }} data-id="element-393">
          Account deletion confirmation
        </h1>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-394">
          Hello,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-395">
          We confirm that your Aisco Workspace account has been successfully
          deleted.
        </p>

        <div style={{
        backgroundColor: '#fef2f2',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #dc2626',
        marginBottom: '32px'
      }} data-id="element-396">
          <p style={{
          margin: '0',
          color: '#991b1b',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-397">
            <strong data-id="element-398">Important:</strong> All your data, projects, and settings
            have been permanently deleted from our systems.
          </p>
        </div>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-399">
          We're sorry to see you go. If you have any feedback about your
          experience or need assistance, please don't hesitate to contact us at{' '}
          <a href="mailto:support@aisco.com" style={{
          color: '#2563eb',
          textDecoration: 'none'
        }} data-id="element-400">
            support@aisco.com
          </a>
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-401">
          If you'd like to return in the future, you're always welcome. You can
          create a new account at any time.
        </p>

        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-402">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#f3f4f6',
          color: '#4b5563',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600',
          border: '1px solid #d1d5db'
        }} data-id="element-403">
            Visit Aisco Workspace
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0',
        textAlign: 'center'
      }} data-id="element-404">
          Thank you for being part of our community.
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-405">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-406">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-407" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}